import { Component, EventEmitter, Input, Output } from "@angular/core";

import { BusinessType } from "src/app/models/enums/businessType.enum";

@Component({
  selector: "app-business-select",
  templateUrl: "./business-select.component.html",
  styleUrls: ["./business-select.component.scss"],
})
export class BusinessSelectComponent {
  @Input() businessTypes: BusinessType[];
  
  @Output() selectBusiness: EventEmitter<BusinessType> = new EventEmitter<BusinessType>();

  businessType = BusinessType;

  constructor() {}

  setSelectedBusinessType(businessType: BusinessType) {
    this.selectBusiness.emit(businessType);
  }
}
